"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageExpiration = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var moment_1 = __importDefault(require("moment"));
require("./PackageExpiration.scss");
var constants_1 = require("@app/shared/constants");
var PackageExpiration = function (props) {
    var diff = moment_1.default(props.expirationDate).diff(moment_1.default.now(), 'seconds');
    var displayIcon = (props.displayIcon === undefined) ? true : props.displayIcon;
    var className = (Number.isNaN(diff)) ? 'uploading' : (diff >= (10 * constants_1.DAYS_IN_SECS)) ? '' : (diff > (5 * constants_1.DAYS_IN_SECS)) ? 'warning' : (diff > 0) ? 'expiring' : 'expired';
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("span", { className: classnames_1.default('icon', (!displayIcon || Number.isNaN(diff)) ? 'is-hidden' : '') },
            react_1.default.createElement("i", { className: "far fa-clock" })),
        react_1.default.createElement("span", null, (props.expirationDate === '') ? props.message || 'Upload Pending' : (diff > 0) ? moment_1.default(props.expirationDate).fromNow(true) : 'EXPIRED')));
};
exports.PackageExpiration = PackageExpiration;
